module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm);
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%= namespace %>, <%= namespace %> h1, <%= namespace %> h2, <%= namespace %> p{ <%= default_text_color.length>0? 'color: '+default_text_color+';' : '' %> } <%  // set lineheight for headline\n    try{ headline_lineheight_offset }catch( e ){ headline_lineheight_offset = \"\"; }\n    var headlineLineHeight =  parseInt( /\\d+/.exec( headline_font_size || \"0\" )[ 0 ] ) + parseInt( /\\-?\\d+/.exec( headline_lineheight_offset || \"0\" )[ 0 ] );\n    headlineLineHeight = headlineLineHeight ? ( headlineLineHeight + \"px\" ) : \"\";\n%> <%= namespace %> h1 { <%= headline_font_size.length>0? 'font-size: '+headline_font_size+';' : '' %> <%= headline_font_size.length>0? 'line-height: '+ headlineLineHeight +';' : '' %> <%= headline_font_color.length>0? 'color: '+headline_font_color+';' : '' %> } <%= namespace %> h2, <%= namespace %> a, <%= namespace %> p { <%= text_font_size.length > 0 ? 'font-size: ' + text_font_size + ';' : '' %> <%= text_font_color.length > 0 ? 'color: ' + text_font_color + ';' : '' %> } <%= namespace %> textarea:-moz-placeholder, <%= namespace %> textarea::-moz-placeholder { <%= textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' %> <%= textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' %> } <%= namespace %> textarea:-ms-input-placeholder { <%= textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' %> <%= textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' %> } <%= namespace %> textarea::-webkit-input-placeholder { <%= textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' %> <%= textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' %> } <%= namespace %> form .char-count{ color: <%= textarea_font_color %> ; } <%= namespace %> textarea { <%= textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' %> <%= textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' %> } <%= namespace %> .call-to-action button { <%= upload_font_size.length>0? 'font-size: '+upload_font_size+';' : '' %> <%= upload_font_color.length>0? 'color: '+upload_font_color+';' : '' %> } <%= namespace %> .call-to-action button.btn-upload svg, <%= namespace %> .call-to-action button.btn-upload svg path, <%= namespace %> .call-to-action button.btn-upload svg polygon { <%= upload_font_color.length>0? 'fill: '+upload_font_color+';' : '' %> } <%= namespace %> .instructions { } <%= namespace %> .call-to-action button.btn-upload{ <%= upload_background.color.length>0? 'background: '+upload_background.color+';' : '' %> <%= upload_background.image.length>0? 'background-image:'+ ( /^https?:\\/\\//.test(upload_background.image)? ' url('+upload_background.image+')' : upload_background.image )+';' : '' %> <%= upload_background.position.length>0? 'background-position: '+upload_background.position+';' : '' %> <%= upload_background.repeat.length>0? 'background-repeat: '+upload_background.repeat+';' : '' %> <%= upload_background.color.length>0? 'background-color: '+upload_background.color+';' : '' %> <%= upload_background.size.length>0? 'background-size: '+upload_background.size+';' : '' %> <%= !!upload_background.margin_top ? 'margin-top: ' + upload_background.margin_top + ';' : '' %> } <%= namespace %> textarea { <%= textarea_background.image.length>0? 'background-image:'+ ( /^https?:\\/\\//.test(textarea_background.image)? ' url('+textarea_background.image+')' : textarea_background.image )+';' : '' %> <%= textarea_background.position.length>0? 'background-position: '+textarea_background.position+';' : '' %> <%= textarea_background.repeat.length>0? 'background-repeat: '+textarea_background.repeat+';' : '' %> <%= textarea_background.color.length>0? 'background-color: '+textarea_background.color+';' : '' %> <%= textarea_background.size.length>0? 'background-size: '+textarea_background.size+';' : '' %> } <%= namespace %> .call-to-action button.btn-submit, <%= namespace %> .call-to-action button.btn-submit:hover, <%= namespace %> .call-to-action button.btn-submit:hover { <%= buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' %> <%= buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' %> <%= buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' %> <%= buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' %> <%= buttons.background.length>0? 'background: '+buttons.background+';' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -moz-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -o-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -ms-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' %> <%= buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' %> } <%= namespace %> .upload-text .upload-success { <%= success_text_color.length>0? 'color: '+success_text_color+';' : '' %> } <%= namespace %> .upload-text .upload-success svg polygon { <%= success_icon_color.length>0? 'fill: '+success_icon_color+';' : '' %> } <%= namespace %> .upload-text .upload-error { <%= error_text_color.length>0? 'color: '+error_text_color+';' : '' %> } <%= namespace %> .upload-text .upload-error svg polygon { <%= error_icon_color.length>0? 'fill: '+error_icon_color+';' : '' %> } <%= namespace %> .upload-text .upload-loading { <%= loading_text_color.length>0? 'color: '+loading_text_color+';' : '' %> }"
  , __filename = undefined;
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append(escapeFn( namespace ))
    ; __append(", ")
    ; __append(escapeFn( namespace ))
    ; __append(" h1, ")
    ; __append(escapeFn( namespace ))
    ; __append(" h2, ")
    ; __append(escapeFn( namespace ))
    ; __append(" p{ ")
    ; __append(escapeFn( default_text_color.length>0? 'color: '+default_text_color+';' : '' ))
    ; __append(" } ")
    ;   // set lineheight for headline
    try{ headline_lineheight_offset }catch( e ){ headline_lineheight_offset = ""; }
    var headlineLineHeight =  parseInt( /\d+/.exec( headline_font_size || "0" )[ 0 ] ) + parseInt( /\-?\d+/.exec( headline_lineheight_offset || "0" )[ 0 ] );
    headlineLineHeight = headlineLineHeight ? ( headlineLineHeight + "px" ) : "";

    ; __line = 5
    ; __append(" ")
    ; __append(escapeFn( namespace ))
    ; __append(" h1 { ")
    ; __append(escapeFn( headline_font_size.length>0? 'font-size: '+headline_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( headline_font_size.length>0? 'line-height: '+ headlineLineHeight +';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( headline_font_color.length>0? 'color: '+headline_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" h2, ")
    ; __append(escapeFn( namespace ))
    ; __append(" a, ")
    ; __append(escapeFn( namespace ))
    ; __append(" p { ")
    ; __append(escapeFn( text_font_size.length > 0 ? 'font-size: ' + text_font_size + ';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( text_font_color.length > 0 ? 'color: ' + text_font_color + ';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea:-moz-placeholder, ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea::-moz-placeholder { ")
    ; __append(escapeFn( textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea:-ms-input-placeholder { ")
    ; __append(escapeFn( textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea::-webkit-input-placeholder { ")
    ; __append(escapeFn( textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" form .char-count{ color: ")
    ; __append(escapeFn( textarea_font_color ))
    ; __append(" ; } ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea { ")
    ; __append(escapeFn( textarea_font_size.length>0? 'font-size: '+textarea_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_font_color.length>0? 'color: '+textarea_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button { ")
    ; __append(escapeFn( upload_font_size.length>0? 'font-size: '+upload_font_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( upload_font_color.length>0? 'color: '+upload_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-upload svg, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-upload svg path, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-upload svg polygon { ")
    ; __append(escapeFn( upload_font_color.length>0? 'fill: '+upload_font_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .instructions { } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-upload{ ")
    ; __append(escapeFn( upload_background.color.length>0? 'background: '+upload_background.color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( upload_background.image.length>0? 'background-image:'+ ( /^https?:\/\//.test(upload_background.image)? ' url('+upload_background.image+')' : upload_background.image )+';' : '' 
))
    ; __append(" ")
    ; __append(escapeFn( upload_background.position.length>0? 'background-position: '+upload_background.position+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( upload_background.repeat.length>0? 'background-repeat: '+upload_background.repeat+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( upload_background.color.length>0? 'background-color: '+upload_background.color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( upload_background.size.length>0? 'background-size: '+upload_background.size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( !!upload_background.margin_top ? 'margin-top: ' + upload_background.margin_top + ';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" textarea { ")
    ; __append(escapeFn( textarea_background.image.length>0? 'background-image:'+ ( /^https?:\/\//.test(textarea_background.image)? ' url('+textarea_background.image+')' : textarea_background.image )+';' : '' 
))
    ; __append(" ")
    ; __append(escapeFn( textarea_background.position.length>0? 'background-position: '+textarea_background.position+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_background.repeat.length>0? 'background-repeat: '+textarea_background.repeat+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_background.color.length>0? 'background-color: '+textarea_background.color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( textarea_background.size.length>0? 'background-size: '+textarea_background.size+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-submit, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-submit:hover, ")
    ; __append(escapeFn( namespace ))
    ; __append(" .call-to-action button.btn-submit:hover { ")
    ; __append(escapeFn( buttons.text_color.length>0? 'color: '+buttons.text_color+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_size.length>0? 'font-size: '+buttons.text_size+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.line_height.length>0? 'line-height: '+buttons.line_height+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.text_align.length>0? 'text-align: '+buttons.text_align+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.background.length>0? 'background: '+buttons.background+';' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -moz-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -webkit-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -o-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: -ms-linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( (buttons.gradient_top.length>0 && buttons.gradient_bottom.length>0)? 'background-image: linear-gradient('+buttons.gradient_top+','+buttons.gradient_bottom+');' : '' ))
    ; __append(" ")
    ; __append(escapeFn( buttons.border_radius.length>0? 'border-radius: '+buttons.border_radius+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .upload-text .upload-success { ")
    ; __append(escapeFn( success_text_color.length>0? 'color: '+success_text_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .upload-text .upload-success svg polygon { ")
    ; __append(escapeFn( success_icon_color.length>0? 'fill: '+success_icon_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .upload-text .upload-error { ")
    ; __append(escapeFn( error_text_color.length>0? 'color: '+error_text_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .upload-text .upload-error svg polygon { ")
    ; __append(escapeFn( error_icon_color.length>0? 'fill: '+error_icon_color+';' : '' ))
    ; __append(" } ")
    ; __append(escapeFn( namespace ))
    ; __append(" .upload-text .upload-loading { ")
    ; __append(escapeFn( loading_text_color.length>0? 'color: '+loading_text_color+';' : '' ))
    ; __append(" }")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

}